interface ServerRenderedRoot {
  dataset: DOMStringMap;
  replaceChildren(...nodes: Node[]): void;
  removeAttribute(name: string): void;
}

/**
 * Adornis' Lit bootstrap renders into the existing root but does not hydrate or remove server HTML.
 * Remove our explicitly marked SEO fallback before mounting the interactive application so users
 * never receive both the server document and the client application at the same time.
 */
export const prepareClientRoot = (root: ServerRenderedRoot | null) => {
  if (!root || root.dataset.vpServerRendered !== 'true') return false;
  root.replaceChildren();
  root.removeAttribute('data-vp-server-rendered');
  return true;
};
